import React, {Component} from "react";
import SearchForm from "../SearchForm/SearchForm";
import {Tabs, Tab} from "react-bootstrap";
import "./SearchControler.css";
import counterpart from "counterpart";
import {Button} from "react-bootstrap";
import Translate from "react-translate-component";
import en from "../langs/en";
// import axios from "axios";

counterpart.registerTranslations("en", en);
// let sectorDropDown = [];
// let passDataArr = [];

class SearchControler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displaySearchTabs: false,
      hsCodes: [],
      countries: [],
    };
  }
  componentDidMount() {
    // Will work after the component loaded
    this.dropDownItems();
  }
  // Render dropdown Items (Industry and sector)
  dropDownItems = () => {
    let codesResp = require("../../resources/classificationHS.json");
    let countries = require("../../resources/countries.json");
    // console.log("Codes: ", codesResp);
    this.setState({
      hsCodes: codesResp.results,
      countries: countries,
    });
  };

  displaySearchTabs = () => {
    this.setState({
      displaySearchTabs: true,
    });
  };

  render() {
    const tabsBtn = <Translate content="tabs.tabsBtn" />;
    const productMarkets = <Translate content="tabs.tab1" />;
    const tradeDevelopment = <Translate content="tabs.tab2" />;
    return (
      <div className="tradeOpt">
        <Button onClick={this.displaySearchTabs} variant="info">
          {tabsBtn}
        </Button>
        {this.state.displaySearchTabs ? (
          <Tabs
            defaultActiveKey="home"
            transition={false}
            id="noanim-tab-example"
          >
            <Tab eventKey="home" title={productMarkets}>
              <SearchForm
                context="discover"
                title={productMarkets}
                codes={this.state.hsCodes}
                countries={this.state.countries}
              />
            </Tab>
            <Tab eventKey="profile" title={tradeDevelopment}>
              <SearchForm
                context="development"
                title={tradeDevelopment}
                codes={this.state.hsCodes}
                countries={this.state.countries}
              />
            </Tab>
          </Tabs>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default SearchControler;
